module.exports = __webpack_public_path__ + "static/arthur-lung-particles-85d957dd58a6204e7275bc8387275192.webm";